var fireEvent;
var manualStateChange = true;
var menu_height;

(function (jQuery) {
	jQuery(document).ready(function () { //when DOM is ready
		theme.init();
	});
	jQuery(window).resize(function () {
		clearTimeout(fireEvent);
		fireEvent = setTimeout(theme.resizeEvent, 200);
	});
})(jQuery);
jQuery(window).load(function () {
	theme.initDropdownMenuWidth();
});

var theme = {
	mosaicTimeout: false,
	init: function () {
		theme.initMenuHeight();
		theme.initShopifyParams();
		theme.initHomeSlider();
		theme.initMobileMenu();
		theme.initBrandsSlider();
		theme.initNewsletterPopup();
		theme.initProductQuickview();
		theme.initProductImageLightbox();
		theme.initSquareCollectionProductImages();
		theme.initSquareProductImages();
		theme.initSquareHomeProductImages();
		theme.initSquareSearchProductImages();
		theme.initSquareCollectionListImages();
		theme.initDropdownMenuWidth();
		theme.initCollectionItemHeight();
		theme.initSearchProductsItemHeight();
		theme.initQuickshopAddToCart();
		theme.initProductImageHoverZoom();
		theme.initPromoImageHoverZoom();
		theme.initQuantityField();
		theme.initSocialShareButtons();
		theme.initReviewsApp();
		theme.initNavigationSelector();
		theme.initHomeDynamicCollection();
		theme.initHomeCollectionSlider();
		theme.initSquareBlogProductImages();
		theme.initComments();
		theme.initCartRemoveProduct();
		theme.initCartProductQuantityChange();
		theme.initCartForm();
		theme.initCustomersLogin();
		theme.initCustomersRecover();
		theme.initCollectionSidebar();
		theme.initCollectionPagination();
		theme.initMenu();
		theme.initCollectionUpdateHistory();
		theme.fixIE11Accelleration();
	},
	initHomeSlider: function() {
		jQuery('.carousel').carousel({
			pause: true,
			interval: false
		});
	},
	initMenuHeight: function() {
		if( window.innerWidth >= 992 )
			menu_height = jQuery('.menu').outerHeight(true);
		else 
			menu_height = 0;
	},
	initMenu: function () {
		if(window.innerWidth >= 992)
		{
			// Bootstrap dropdown on hover
			// --------------------------------------------------
			jQuery('.nav li.dropdown').hover(function () {
				jQuery(this).addClass('open');
			}, function () {
				jQuery(this).removeClass('open');
			});
		
			var affix_height = theme.getAffixHeight();
			jQuery('.affix-wrapper').height(affix_height + menu_height);
			jQuery('.affix-data').affix({ offset: { top: affix_height } });
		}
	},
	getAffixHeight: function() {
		var affix_height = jQuery('.header').outerHeight(true) + jQuery('.dock').outerHeight(true);
		return affix_height;
	},
	initMobileMenu: function() {
		// Open responsive menu submenus
		// --------------------------------------------------
		jQuery('.dropdown-toggle').on('click', function(e) {
			if(window.innerWidth < 992)
			{
				if(!jQuery(this).parent().hasClass('open-responsive'))
				{
					jQuery(this).parent().addClass('open-responsive');

					var close_link = '<a href="#" class="close-responsive"></a>';
					jQuery(this).parent().append(close_link);

					e.preventDefault();
				}
			}
		});            

		// Close responsive sub menu
		// --------------------------------------------------
		jQuery('.menu-item').on('click', '.close-responsive', function(e) {
			if(window.innerWidth < 992)
			{
				jQuery(this).parent().removeClass('open-responsive');
				jQuery(this).remove();

				return false;
			}
		});  

		// Show & hide responsive menu
		// --------------------------------------------------
		jQuery('.responsive-menu').on('click', function(e) {

			if(window.innerWidth < 992)
			{
				var active = false;
				if(jQuery(this).hasClass('active'))
				{
					active = true;
				}

				jQuery('.container-fluid.menu, .search-content, .responsive-cart').removeClass('visible-responsive');
				jQuery('.responsive-search, .responsive-menu, .responsive-account').removeClass('active');

				if(!active)
				{
					jQuery(this).addClass('active');
					jQuery('.container-fluid.menu').addClass('visible-responsive');
				}

				e.preventDefault();
			}
		});

		// Show & hide responsive search
		// --------------------------------------------------
		jQuery('.responsive-search').on('click', function(e) {

			if(window.innerWidth < 992)
			{
				var active = false;
				if(jQuery(this).hasClass('active'))
				{
					active = true;
				}

				jQuery('.container-fluid.menu, .search-content, .responsive-cart').removeClass('visible-responsive');
				jQuery('.responsive-search, .responsive-menu, .responsive-account').removeClass('active');

				if(!active)
				{
					jQuery(this).addClass('active');
					jQuery('.search-content').addClass('visible-responsive');
				}
				e.preventDefault();
			}
		});

		// Show & hide responsive accounts
		// --------------------------------------------------
		jQuery('.responsive-account').on('click', function(e) {

			if(window.innerWidth < 992)
			{
				var active = false;
				if(jQuery(this).hasClass('active'))
				{
					active = true;
				}

				jQuery('.container-fluid.menu, .search-content, .responsive-cart').removeClass('visible-responsive');
				jQuery('.responsive-search, .responsive-menu, .responsive-account').removeClass('active');

				if(!active)
				{
					jQuery(this).addClass('active');
					jQuery('.responsive-cart').addClass('visible-responsive');
				}
				e.preventDefault();
			}
		});

    },
	initBrandsSlider: function() {
		// change item count in a row depending on device
		// --------------------------------------------------
		window_width = window.innerWidth;
		var slider = jQuery('#brands-slider');
		if (window_width < 992)
		{
			var slider_inner = slider.find('.carousel-inner');
			var columns = slider_inner.find('.col');
			slider_inner.find('.item').remove();
			
			if(window_width < 768)
			{
				// Phone - 1 column in a row
				columns.each(function(){
					slider_inner.append('<div class="item"><div class="row"><div class="col col-xs-12">' + jQuery(this).html() + '</div></div></div>');
				});
			}
			else
			{
				// Tablet - 2 columns in a row
				if (columns.length > 1)
				{
					for (i = 1; i < columns.length; i += 2)
					{
						slider_inner.append('<div class="item"><div class="row"><div class="col col-sm-6">' + columns.eq(i-1).html() + '</div><div class="col col-sm-6">' + columns.eq(i).html() + '</div></div></div>');
					}
					if (columns.length % 2 != 0)
					{
						slider_inner.append('<div class="item"><div class="row"><div class="col col-sm-6">' + columns.eq(columns.length - 1).html() + '</div></div></div>');
					}
				}
				else 
				{
					slider_inner.append('<div class="item"><div class="row"><div class="col col-sm-6">' + columns.eq(0).html() + '</div></div></div>');
				}	
			}
			slider_inner.find('.item').eq(0).addClass('active');
		}
		
		slider.carousel({
			interval: 5000
		});
		
		slider.find('.carousel-control.left').click(function(){
			slider.carousel('prev');
			return false;
		});
		slider.find('.carousel-control.right').click(function(){
			slider.carousel('next');
			return false;
		});	
	},
	initProductQuickview: function () {
		// Show & hide Quickview
		// --------------------------------------------------
		jQuery('.btn-quickview').on('click', function (e) {
			jQuery('.focus').addClass('out-of-focus');
			jQuery('.quickview').css('top', jQuery(document).scrollTop());
			jQuery('.quickview').addClass('open').hide();

			var pr_handle = jQuery(this).attr('pr_handle');
			theme.initAjaxQuickshop(pr_handle);
			
			e.preventDefault();
		});
		jQuery('.quickview .close').on('click', function (e) {
			jQuery('.focus').removeClass('out-of-focus');
			jQuery('.quickview').removeClass('open');

			jQuery('.quickview').hide();
			jQuery('.quickview .catalog-item').remove();

			e.preventDefault();
		});
	},
	initProductImageLightbox: function () {
		// Product page - image lightbox popup
		// --------------------------------------------------
		var lb = jQuery('.image-lightbox');
		var focus = jQuery('.focus');
		var open = jQuery('.open-lightbox');
		var remote_trigger = jQuery('body.template-product .image-slides');
		var close = jQuery('.lightbox-close');

		open.click(function () {
			if (window.innerWidth < 768) return false;
			
			focus.addClass('out-of-focus');
			var loader = '<div class="quickview-loader"><i class="fa fa-repeat fa-spin"></i></div>';
			jQuery('body').prepend(loader);

			var img_url = jQuery(this).siblings('.image-slides').children('.image.active').not('.cycle-sentinel').attr('data-lightbox');
			
			var img = jQuery("<img />").attr('src', img_url)
					.on('load', function () {
						if (!this.complete || typeof this.naturalWidth == "undefined" || this.naturalWidth == 0) {
							alert('broken image!');
						} else {
							lb.children('div').html(img);
							jQuery('.quickview-loader').remove();
							lb.show(function () {
								jQuery(this).addClass('open');
								close.addClass('show');
							});
						}
					});
			return false;
		});

		remote_trigger.click(function () {
			open.trigger("click");
		});

		close.click(function () {
			lb.hide(function () {
				jQuery(this).removeClass('open');
				close.removeClass('show');
				focus.removeClass('out-of-focus');
			});
			return false;
		});
	},
	resizeEvent: function () {
		theme.initSquareCollectionProductImages();
		theme.initSquareProductImages();
		theme.initSquareHomeProductImages();
		theme.initSquareSearchProductImages();
		theme.initSquareBlogProductImages();
		theme.initSquareCollectionListImages();
		
		// Home page - collection slider block
		var slider_item = jQuery('.collection-slider-item.active');
		slider_item.find('.item').css({'visibility': 'hidden', 'display': 'block', 'position': 'absolute', 'width': '100%'});
		theme.resizeCollectionSlider(slider_item);
		slider_item.find('.item').attr('style', '');
		
		theme.initDropdownMenuWidth();
		

		if(window.innerWidth >= 992) {
			var affix_height = theme.getAffixHeight();
			jQuery('.affix-wrapper').height(affix_height + menu_height);
			jQuery(window).off('.affix');
			jQuery('.affix-data').removeData('bs.affix').removeClass('affix affix-top affix-bottom');		
			jQuery('.affix-data').affix({ offset: { top: affix_height } });						
		} else {
			jQuery('.affix-wrapper').height('');
		}
	},
	initSquareCollectionProductImages: function () {
		// Same width & height for images in collection products grid
		// --------------------------------------------------
		theme.resizeSquareProductImageCollection(jQuery('body.template-collection .products-grid .item-single .image'));
	},
	initSquareProductImages: function () {
		// Same width & height for images in Product page
		// --------------------------------------------------
		theme.resizeSquareProductImageCollection(jQuery('body.template-product .product-image-wrapper .image'));
	},
	initSquareBlogProductImages: function () {
		// Same width & height for images in blog sidebar products grid
		// --------------------------------------------------
		theme.resizeSquareProductImageCollection(jQuery('.sidebar-filters .products .item-single .image'));
	},
	initSquareHomeProductImages: function () {
		// Same width & height for images in Home products grid
		// --------------------------------------------------
		theme.resizeSquareProductImageCollection(jQuery('.dynamic-col-item.active .item-single .image'));
		theme.resizeSquareProductImageCollection(jQuery('.dynamic-col-item.active .item-single .image-slides'));
	},
	initSquareSearchProductImages: function () {
		// Same width & height for images in Search results page
		// --------------------------------------------------
		theme.resizeSquareProductImageCollection(jQuery('body.template-search .products-grid .item-single .image'));
	},
	initSquareCollectionListImages: function() {
		// Same width & height for images in Collection list page
		// --------------------------------------------------
		theme.resizeSquareProductImageCollection(jQuery('body.template-list-collections .collection-image'));
	},
	resizeSquareProductImageCollection: function (image) {
		image.each(function () {
			jQuery(this).height(jQuery(this).width());
		});
	},
	initDropdownMenuWidth: function () {
		// Set width to dropdown menu based on first level children
		// --------------------------------------------------
		if(window.innerWidth >= 992) {
			jQuery('.dropdown-menu').each(function () {
				var sum = 0;
				jQuery(this).children('.section').each(function () {
					sum += jQuery(this).outerWidth(true);
				});
				jQuery(this).width(sum + 1);
			});
		}
	},
	initCollectionItemHeight: function () {
		//3 items in a row
		var items = jQuery('body.template-collection .products-grid .col-md-4 .item-single .details');
		theme.resizeRowItemHeight(items, 3);

		//4 items in a row
		items = jQuery('body.template-collection .products-grid .col-md-3 .item-single .details');
		theme.resizeRowItemHeight(items, 4);
	},
	initHomeCollectionItemHeight: function (wrapper) {
		//3 items in a row
		var items = wrapper.find('.col-md-4 .item-single .details');
		theme.resizeRowItemHeight(items, 3);

		//4 items in a row
		items = wrapper.find('.col-md-3 .item-single .details');
		theme.resizeRowItemHeight(items, 4);
	},
	initSearchProductsItemHeight: function () {
		//3 items in a row
		var items = jQuery('body.template-search .products-grid .col-md-4 .item-single .details');
		theme.resizeRowItemHeight(items, 3);

		//4 items in a row
		items = jQuery('body.template-search .products-grid .col-md-3 .item-single .details');
		theme.resizeRowItemHeight(items, 4);
	},
	resizeRowItemHeight: function (items, columns) {
		if (window.innerWidth < 768 || items.length === 0)
		{
			return false;
		}
		var chunks = chunk(items, columns);

		for (var row in chunks)
		{
			if (typeof chunks[row] !== "undefined")
			{
				chunks[row].height(''); //reset previous height
				var maxHeight = Math.max.apply(null, chunks[row].map(function ()
				{
					return jQuery(this).height();
				}).get());
				if (maxHeight > 0)
				{
					chunks[row].height(maxHeight);
					chunks[row].addClass('height-adjusted');
				}
			}
		}
	},
	resizeToMaxHeight: function (items, target) {
		if (window.innerWidth < 768 || items.length === 0)
		{
			return false;
		}
		
		var maxHeight = Math.max.apply(null, items.map(function ()
		{
			return jQuery(this).outerHeight();
		}).get());
		if (maxHeight > 0)
		{
			target.height(maxHeight);
		}
	},
	resizeCollectionSlider: function (slider_item) {
		if( window.innerWidth < 768 ) {
			theme.resizeSquareProductImageCollection(slider_item.find('.item-single .image'));
			theme.resizeSquareProductImageCollection(slider_item.find('.item-single .image-slides'));
		} else {
			slider_item.find('.item-single .image').each(function () {
				jQuery(this).height('');
			});
			slider_item.find('.item-single .image-slides').each(function () {
				jQuery(this).height('');
			});
		}
		theme.initHomeCollectionItemHeight(slider_item);
		theme.resizeToMaxHeight(slider_item.find('.item > div'), jQuery('.collection-slider-item .carousel-inner'));
	},
	initComments: function () {
		// Blog article page - comment submit
		// --------------------------------------------------
		jQuery('#comment-submit').click(function (e) {
			e.preventDefault();
			jQuery(this).parents('#comment_form').submit();
		});
		
		// Blog article page - set textarea height for comment form
		// --------------------------------------------------
		if(window.innerWidth >= 992) {
			jQuery('.add-comment .comment').outerHeight(jQuery('.add-comment .data').eq(0).outerHeight());
		}
	},
	initCustomersLogin: function () {
		// Customer login page - switch between login and recover form
		// --------------------------------------------------
		var login_form = jQuery('#customer-login-form');
		var recover_form = jQuery('#recover-password-form');

		jQuery('#recover-password-link').click(function (e) {
			e.preventDefault();
			login_form.fadeOut(300, function () {
				recover_form.show();
			});
		});
		jQuery('#login-form-link').click(function (e) {
			e.preventDefault();
			recover_form.fadeOut(300, function () {
				login_form.show();
			});
		});
	},
	initCustomersRecover: function () {
		// Customer login page - display recover form on page load
		// --------------------------------------------------
		if (window.location.hash == '#recover') {
			document.getElementById('customer-login-form').style.display = 'none';
			document.getElementById('recover-password-form').style.display = 'block';
		}
	},
	initQuickshopAddToCart: function () {
		// Add simple product to cart
		// --------------------------------------------------
		jQuery('.ajax-to-cart').click(function () {
			var elem = jQuery(this);
			var form = jQuery(elem.closest('form'));

			var url_string = form.serialize();
			theme.initAjaxAddToCart(elem, url_string);

			return false;
		});
	},
	initAjaxQuickshop: function (pr_handle) {
		// Ajax product request by product handle
		// --------------------------------------------------
		jQuery.ajax({
			type: "get",
			url: "/products/" + pr_handle,
			dataType: 'html',
			beforeSend: function () {
				var loader = '<div class="quickview-loader"><i class="fa fa-repeat fa-spin"></i></div>';
				jQuery('body').prepend(loader);
			},
			success: function (data) {
				var page = jQuery(data);
				var product = page.find('.catalog-item');

				jQuery('.quickview-loader').remove();

				jQuery('.quickview-inner').append(product);

				theme.initSocialShareButtons();
				jQuery('.quickview .cycle-slideshow').cycle();
				theme.initProductImageHoverZoom();
				theme.initQuantityField();
				theme.initQuickshopAddToCart();
				jQuery('.quickview').show();
			},
			error: function (xhr, text) {

			},
			complete: function () {

			}
		});
	},
	initAjaxAddToCart: function (elem, url_string) {
		// Ajax product add to cart
		// --------------------------------------------------
		jQuery.ajax({
			type: "post",
			url: "/cart/add.js",
			data: url_string,
			dataType: 'json',
			beforeSend: function () {
				elem.children('i').replaceWith('<i class="fa fa-repeat fa-spin"></i>');
			},
			success: function (msg) {
				elem.children('i').replaceWith('<i class="fa fa-check"></i>');
				theme.updateCartAmounts();
			},
			error: function (xhr, text) {
				elem.children('i').replaceWith('<i class="fa fa-close"></i>');
			},
			complete: function () {
				setTimeout(function () {
					elem.children('i').replaceWith('<i class="fa fa-shopping-cart"></i>');
				}, 3000);
			}
		});
	},
	initCollectionSidebarSort: function () {
		//set sort-by select default value
		var sort_by = jQuery('#sort-by');
		var sort_by_val = sort_by.attr('data-default-val');
		sort_by.val(sort_by_val);

		sort_by.val(sort_by_val).bind('change', function () {
			delete Shopify.queryParams.page;
			Shopify.queryParams.sort_by = jQuery(this).val();

			theme.initAjaxLoadCollection(theme.getCollectionConstraintURL());
		});
	},
	initCollectionSidebar: function () {
		// Product Tag Filters, Collection sorting
		// --------------------------------------------------

		//disable not checked unavailable filters
		jQuery('.coll-filter.disabled input:not(:checked)').attr('disabled', 'disabled');
		//sort-by select
		theme.initCollectionSidebarSort();

		//filter items
		var collFilters = jQuery('.coll-filter input');
		collFilters.change(function () {
			delete Shopify.queryParams.page;
			var newTags = [];

			collFilters.each(function () {
				if (jQuery(this).is(':checked'))
					newTags.push(jQuery(this).val());
			});

			if (newTags.length)
				Shopify.queryParams.constraint = newTags.join('+');
			else
				delete Shopify.queryParams.constraint;

			theme.initAjaxLoadCollection(theme.getCollectionConstraintURL());
		});

		//collection select
		var coll_select = jQuery('#collection-selector');
		if (coll_select.length > 0)
		{
			coll_select.change(function () {
				theme.initAjaxLoadCollection(jQuery('option:selected', jQuery(this)).attr('value'));
			});
		}
	},
	initCollectionUpdateHistory: function () {
		// Collection products page - go back, go forward
		// --------------------------------------------------
		History.Adapter.bind(window, 'statechange', function () {
			if (manualStateChange == true) {
				var url = window.location.href;
				theme.initAjaxLoadCollection(url);
			}
			manualStateChange = true;
		});
	},
	initShopifyParams: function () {
		if (jQuery('body.template-collection').length && typeof Shopify.queryParams == "undefined") {
			Shopify.queryParams = {};
			if (location.search.length) {
				for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
					aKeyValue = aCouples[i].split('=');
					if (aKeyValue.length > 1) {
						Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
					}
				}
			}
		}
	},
	getCollectionConstraintURL: function () {
		theme.initShopifyParams();
		var location_search = jQuery.param(Shopify.queryParams).replace(/\%2B/g, '+');
		var location_url = window.location.pathname;
		location_url += location_search != "" ? "?" + location_search : "";

		return location_url;
	},
	initCollectionPagination: function () {
		var pagination_disabled = jQuery('body.template-collection .pagination li.active a, body.template-collection .pagination li.disabled a');

		pagination_disabled.click(function (e) {
			e.preventDefault();
		});

		var pagination = jQuery('body.template-collection .pagination li.clickable a');

		pagination.click(function (e) {
			e.preventDefault();

			//setup page params
			var temp_params = Shopify.queryParams;
			temp_params.page = jQuery(this).attr('data-page-index');

			var location_search = jQuery.param(temp_params).replace(/\%2B/g, '+');
			var location_url = window.location.pathname;
			location_url += location_search != "" ? "?" + location_search : "";

			//load ajax content of the page
			var location_url = theme.getCollectionConstraintURL();
			theme.initAjaxLoadCollection(location_url);
		});
	},
	initAjaxLoadCollection: function (url) {
		jQuery.ajax({
			type: "get",
			url: url,
			dataType: 'html',
			beforeSend: function () {
				var loader = '<div class="quickview-loader"><i class="fa fa-repeat fa-spin"></i></div>';
				jQuery('.focus').addClass('out-of-focus');
				jQuery('body').prepend(loader);
				if(window.innerWidth < 992 || jQuery('.affix-data').hasClass('affix')) jQuery('html,body').animate({scrollTop: jQuery("#breadcrumb").offset().top}, 300);
				manualStateChange = false;
				History.pushState(null, null, url);
			},
			success: function (data) {
				theme.initShopifyParams();
				var page = jQuery(data);
				var breadcrumb = page.find('#breadcrumb');
				var content = page.find('#collection-products');

				jQuery('.quickview-loader').remove();
				jQuery('.focus').removeClass('out-of-focus');

				jQuery('#breadcrumb').replaceWith(breadcrumb);
				jQuery('#collection-products').replaceWith(content);
				jQuery('.coll-filter.disabled input:not(:checked)').attr('disabled', 'disabled');
				theme.initCollectionSidebarSort();
				jQuery('.selectpicker').selectpicker();
				jQuery('.cycle-slideshow').cycle();
				theme.initSquareCollectionProductImages();
				theme.initCollectionItemHeight();
				theme.initProductImageHoverZoom();
				theme.initProductQuickview();
				theme.initQuickshopAddToCart();
				theme.initCollectionSidebar();
				theme.initCollectionPagination();
			},
			error: function (xhr, text) {
				window.location = url;
			},
			complete: function () {
				
			}
		});
	},
	initCartRemoveProduct: function () {
		jQuery('body.template-cart form .remove').click(function () {
			var elem = jQuery(this);
			var form = jQuery(elem.parent('form'));
			var id = form.find('input[name=id]').val();

			form.slideUp(1000, function () {
				theme.initAjaxCartQuantityChange(id, 0);
				form.remove();
			});

			return false;
		});
	},
	initCartProductQuantityChange: function () {
		jQuery("body.template-cart .quantity input").change(function () {
			var elem = jQuery(this);
			var qty = parseInt(elem.val());
			var form = jQuery(elem.parents('form').eq(0));
			var id = form.find('input[name=id]').val();

			theme.initAjaxCartQuantityChange(id, qty);

			return false;
		});
	},
	initAjaxCartQuantityChange: function (id, qty) {
		jQuery.ajax({
			type: "post",
			url: "/cart/change.js",
			data: {
				quantity: qty,
				id: id
			},
			dataType: 'json',
			beforeSend: function () {

			},
			success: function (msg) {
				Shopify.getCart(function (cart) {
					jQuery('.cart-total-money-amount').html(Shopify.formatMoney(msg.total_price, window._money_format));
				});
				if (qty !== 0)
					theme.initCartItemPriceUpdate(jQuery('#' + id), qty);
				theme.initCartTotalPriceUpdate(msg.total_price);
              
              	console.log(msg.item_count);

			},
			error: function (xhr, text) {

			},
			complete: function () {

			}
		});
	},
	initCartItemPriceUpdate: function (elem, qty) {
		var unit_price = parseInt(elem.attr('data-price'));
		var line_price = unit_price * qty;
		elem.attr('data-line-price', line_price)

		var unit_price_comp, line_price_comp, new_price;

		if (elem.attr('data-price-varies') == "true") {
			unit_price_comp = parseInt(elem.attr('data-price-compare'));
			line_price_comp = unit_price_comp * qty;

			elem.attr('data-line-price-compare', line_price_comp)
			new_price = "<span>" + Shopify.formatMoney(line_price, window._money_format) + "<s>" + Shopify.formatMoney(line_price_comp, window._money_format) + "</s></span>";
		} else {
			elem.attr('data-line-price-compare', line_price)
			new_price = Shopify.formatMoney(line_price, window._money_format);
		}

		elem.find('.subtotal').html(new_price);
	},
	initCartTotalPriceUpdate: function (total_price) {
		var cart_form = jQuery('form.cart');
		var total_varies = cart_form.attr('data-total-varies');
		var new_price;
		if (total_varies == 'true') {
			var compare_price = 0;
			jQuery('.cart-items form').each(function () {
				compare_price += parseInt(jQuery(this).attr('data-line-price-compare'));
			});
			new_price = "<span>" + Shopify.formatMoney(total_price, window._money_format) + "<s>" + Shopify.formatMoney(compare_price, window._money_format) + "</s></span>";
		} else {
			new_price = Shopify.formatMoney(total_price, window._money_format);
		}
		cart_form.find('.total-value').html(new_price);
	},
	initCartForm: function () {
		jQuery('#proceed-checkout').click(function () {
			jQuery('input.proceed-checkout').trigger('click');
			return false;
		});
		jQuery('#update-cart').click(function () {
			jQuery('input.update-cart').trigger('click');
			return false;
		});
	},
	updateCartAmounts: function () {
		// update cart money amount located in header
		// --------------------------------------------------
		Shopify.getCart(function (cart) {
			jQuery('.cart-total-money-amount').html(Shopify.formatMoney(cart.total_price, window._money_format));
		});
	},
	initProductImageHoverZoom: function () {
		var wrapper = '.product-image-wrapper.zoom-enabled';
		jQuery(wrapper).find('.image').css('background-size', '100%');
		var slide = '.image';
		var opts = jQuery('.cycle-slideshow').data('cycle.opts');

		

		// Product image zoom on hover
		// --------------------------------------------------
		jQuery(wrapper).hover(
			function () {
				if (typeof opts !== 'undefined' && typeof opts.busy !== 'undefined' && opts.busy) {
					return false;
				}
				jQuery(this).find(slide).stop(true).animate({
					backgroundSize: '105%',
					easing: 'swing'
				}, 100);
			},
			function () {
				jQuery(this).find(slide).animate({
					backgroundSize: '100%',
					easing: 'swing'
				}, 100);
			}
		);
	},
	initPromoImageHoverZoom: function() {
		// Home page banners image zoom on hover
		// --------------------------------------------------
		var banner = '.promo-banners .banner';
		var col_inner = '.col-inner'
		
		jQuery(banner).hover(
			function () {
				jQuery(this).find(col_inner).stop(true).animate({
					backgroundSize: '105%',
					easing: 'swing'
				}, 100);
			},
			function () {
				jQuery(this).find(col_inner).animate({
					backgroundSize: '100%',
					easing: 'swing'
				}, 100);
			}
		);
	},
	initQuantityField: function () {
		// Product quantity input field
		// --------------------------------------------------
		jQuery('.quantity input[type=number]').on('keyup change', function (e) {
			if (parseInt(jQuery(this).val()) > parseInt(jQuery(this).attr('max'))) {
				var max_val = jQuery(this).attr('max');
				jQuery(this).val(max_val);
			}
		});

		jQuery('.quantity .plus').click(function (e) {

			var quantity = jQuery(this).parent().siblings('input[type=number]');
			var newQuantity = parseInt(quantity.val()) + 1;
			if (quantity.attr('max') > parseInt(quantity.val())) {
				quantity.val(newQuantity).trigger('change');
			}
			return false;
		});

		jQuery('.quantity .minus').click(function (e) {

			var quantity = jQuery(this).parent().siblings('input[type=number]');
			var oldQuantity = parseInt(quantity.val());
			if (oldQuantity > 1)
			{
				var newQuantity = oldQuantity - 1;
				quantity.val(newQuantity).trigger('change');
			}
			return false;
		});
	},
	initSocialShareButtons: function () {
		// Product and article sharing
		// --------------------------------------------------
		if (jQuery('.share-button').length > 0)
		{
			var button = jQuery('.share-button').eq(0);

			config = {
				url: button.data().url,
				title: button.data().title,
				description: button.data().description,
				image: button.data().image,
				ui: {
					buttonText: button.data().buttonText,
					icon_font: false,
					flyout: 'bottom right'
				},
				networks: {
					whatsapp: {
						enabled: false
					},
					reddit: {
						enabled: false
					},
					email: {
						enabled: false
					}
				}
			};

			var share = new ShareButton(config);
		}
	},
	initReviewsApp: function () {
		// Product page - add vote count to review tab title
		// --------------------------------------------------
		var meta_container = jQuery('meta[itemprop=votes]');
		if (typeof meta_container != 'undefined') {
			jQuery('#review-vote-count').text(meta_container.attr('content'));
		}
	},
	initNavigationSelector: function () {
		// redirect to selected collection on dropdown change
		// --------------------------------------------------
		var selector = jQuery('.navigation-selector');

		if (selector.length > 0)
		{
			selector.change(function () {
				window.location = jQuery('option:selected', jQuery(this)).attr('value');
			});
		}
	},
	initHomeDynamicCollection: function () {
		// Home page - dynamic collection block
		// --------------------------------------------------
		theme.initHomeCollectionItemHeight(jQuery('.dynamic-col-item.active'));

		var menu_items = jQuery('.dynamic-col-switcher .dropdown-menu a');
		menu_items.click(function (e) {
			e.preventDefault();
			var menu_next = jQuery(this);

			if (menu_next.hasClass('active')) {
				return false;
			}

			var menu_title = jQuery('.dynamic-col-switcher .title-wrapper .title span');
			var new_title = menu_next.children('span').text();
			menu_title.text(new_title);

			menu_items.removeClass('active');
			menu_next.addClass('active');

			var cat_handle = menu_next.attr('data-cat-handle');
			var curr_cat = jQuery('.dynamic-col-item.active');
			var next_cat = jQuery('.dynamic-col-item[data-cat-handle=' + cat_handle + ']');

			//set images for not loaded collections
			if (!next_cat.hasClass('loaded')) {
				next_cat.find('.image-slides .image').each(function () {
					var img_url = jQuery(this).attr('data-img');
					jQuery(this).css('background-image', 'url(' + img_url + ')');
				});

				var slide_wrap = next_cat.find('.image-slides');
				slide_wrap.cycle({log: false});

				next_cat.addClass('loaded');
			}

			curr_cat.fadeOut('300', function () {
				next_cat.css({'visibility': 'hidden', 'display': 'block', 'position': 'absolute', 'width': '100%'});

				//adjust height of slider images and wrappers of images
				theme.resizeSquareProductImageCollection(next_cat.find('.image'));
				theme.resizeSquareProductImageCollection(next_cat.find('.image-slides'));

				//adjust height of details block
				theme.initHomeCollectionItemHeight(next_cat);

				next_cat.attr('style', '');

				curr_cat.removeClass('active');
				next_cat.fadeIn('300').addClass('active');
			});
		});
	},
	initHomeCollectionSlider: function () {
		// Home page - collection slider block
		// --------------------------------------------------
		var slider_item = jQuery('.collection-slider-item.active');
		slider_item.find('.item').css({'visibility': 'hidden', 'display': 'block', 'position': 'absolute', 'width': '100%'});
		theme.resizeCollectionSlider(slider_item);
		slider_item.find('.item').attr('style', '');

		var menu_items = jQuery('.collection-slider-switcher .dropdown-menu a');
		menu_items.click(function (e) {
			e.preventDefault();
			var menu_next = jQuery(this);

			if (menu_next.hasClass('active')) {
				return false;
			}

			var menu_title = jQuery('.collection-slider-switcher .title-wrapper .title span');
			var new_title = menu_next.children('span').text();
			menu_title.text(new_title);

			menu_items.removeClass('active');
			menu_next.addClass('active');

			var cat_handle = menu_next.attr('data-cat-handle');
			var curr_cat = jQuery('.collection-slider-item.active');
			var next_cat = jQuery('.collection-slider-item[data-cat-handle=' + cat_handle + ']');

			//set images for not loaded collections
			if (!next_cat.hasClass('loaded')) {
				next_cat.find('.image-slides .image').each(function () {
					var img_url = jQuery(this).attr('data-img');
					jQuery(this).css('background-image', 'url(' + img_url + ')');
				});

				var slide_wrap = next_cat.find('.image-slides');
				slide_wrap.cycle({log: false});

				next_cat.addClass('loaded');
			}

			curr_cat.fadeOut('300', function () {
				next_cat.css({'visibility': 'hidden', 'display': 'block', 'position': 'absolute', 'width': '100%'});
				next_cat.find('.item').css({'visibility': 'hidden', 'display': 'block', 'position': 'absolute', 'width': '100%'});

				theme.resizeCollectionSlider(next_cat);

				next_cat.find('.item').attr('style', '');
				next_cat.attr('style', '');

				curr_cat.removeClass('active');
				next_cat.fadeIn('300').addClass('active');
			});

		});
	},
	initMap: function () {
		// Home page, Contacts page - google map
		// --------------------------------------------------
		var map = jQuery('#map');
		if (map.length > 0)
		{
			map.each(function () {
				var id = jQuery(this).attr('id');
				var lat = jQuery(this).attr('data-lat');
				var lng = jQuery(this).attr('data-lng');
				var marker_lat = jQuery(this).attr('data-marker_lat');
				var marker_lng = jQuery(this).attr('data-marker_lng');
				var zoom = jQuery(this).attr('data-zoom');
				theme.loadMap(id, lat, lng, marker_lat, marker_lng, zoom);
			});
		}
	},
	loadMap: function (id, lat, lng, marker_lat, marker_lng, zoom) {
		var mapOptions = {
			center: new google.maps.LatLng(lat, lng),
			zoom: parseInt(zoom),
			zoomControl: true,
			zoomControlOptions: {
				style: google.maps.ZoomControlStyle.SMALL,
			},
			disableDoubleClickZoom: true,
			mapTypeControl: false,
			scaleControl: false,
			scrollwheel: false,
			panControl: false,
			streetViewControl: false,
			draggable: true,
			overviewMapControl: false,
			overviewMapControlOptions: {
				opened: false,
			},
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: [
				{
					featureType: "landscape",
					stylers: [
						{saturation: -100},
						{lightness: 65},
						{visibility: "on"}
					]
				}, {
					featureType: "poi",
					stylers: [
						{saturation: -100},
						{lightness: 51},
						{visibility: "simplified"}
					]
				}, {
					featureType: "road.highway",
					stylers: [
						{saturation: -100},
						{visibility: "simplified"}
					]
				}, {
					featureType: "road.arterial",
					stylers: [
						{saturation: -100},
						{lightness: 30},
						{visibility: "on"}
					]
				}, {
					featureType: "road.local",
					stylers: [
						{saturation: -100},
						{lightness: 40},
						{visibility: "on"}
					]
				}, {
					featureType: "transit",
					stylers: [
						{saturation: -100},
						{visibility: "simplified"}
					]
				}, {
					featureType: "administrative.province",
					stylers: [
						{visibility: "off"}
					]
				}, {
					featureType: "water",
					elementType: "labels",
					stylers: [
						{visibility: "on"},
						{lightness: -25},
						{saturation: -100}
					]
				}, {
					featureType: "water",
					elementType: "geometry",
					stylers: [
						{hue: "#ffff00"},
						{lightness: -25},
						{saturation: -97}
					]
				}
			]
		};

		var mapElement = document.getElementById(id);
		var map = new google.maps.Map(mapElement, mapOptions);

		if (marker_lat.length > 0 && marker_lng.length > 0)
		{
			var locations = [
				['home-marker', 'undefined', 'undefined', 'undefined', 'undefined', marker_lat, marker_lng, 'https://i.imgur.com/WtR1DIk.png']
			];

			for (i = 0; i < locations.length; i++)
			{
				if (locations[i][1] == 'undefined') {
					description = '';
				} else {
					description = locations[i][1];
				}
				if (locations[i][2] == 'undefined') {
					telephone = '';
				} else {
					telephone = locations[i][2];
				}
				if (locations[i][3] == 'undefined') {
					email = '';
				} else {
					email = locations[i][3];
				}
				if (locations[i][4] == 'undefined') {
					web = '';
				} else {
					web = locations[i][4];
				}
				if (locations[i][7] == 'undefined') {
					markericon = '';
				} else {
					markericon = locations[i][7];
				}
				marker = new google.maps.Marker({
					icon: markericon,
					position: new google.maps.LatLng(locations[i][5], locations[i][6]),
					map: map,
					title: locations[i][0],
					desc: description,
					tel: telephone,
					email: email,
					web: web
				});
				link = '';
			}
		}
	},
	initNewsletterPopup: function() {
		// Home page - newsletter popup block
		// --------------------------------------------------
		var wrapper = jQuery('.newsletter-popup');
		var cookie = theme.readCookie('newsletter');
		
		if (wrapper.length > 0 && cookie != '1') {
			//Add record to cookies
			theme.createCookie('newsletter', 1, 1);
			
			jQuery('.focus').addClass('out-of-focus');
			wrapper.addClass('open');
			
			wrapper.find('.close').on('click', function (e) {
				jQuery('.focus').removeClass('out-of-focus');
				wrapper.removeClass('open');

				e.preventDefault();
			});
		}
	},
	createCookie: function(name, value, days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			var expires = "; expires="+date.toGMTString();
		}
		else var expires = "";
		document.cookie = name+"="+value+expires+"; path=/";
	},
	readCookie: function(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	},
	eraseCookie: function(name) {
		theme.createCookie(name,"",-1);
	},
	fixIE11Accelleration: function() {
		if(navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
		  jQuery('body').on("mousewheel", function () {
		    event.preventDefault();
		    var wd = event.wheelDelta;
		    var csp = window.pageYOffset;
		    window.scrollTo(0, csp - wd);
		  });
		}
	}
};

//split array in chunks
function chunk(arr, len) {
	var chunks = [],
		i = 0,
		n = arr.length;

	while (i < n) {
		chunks.push(arr.slice(i, i += len));
	}

	return chunks;
}

var Shopify = Shopify || {};

Shopify.optionsMap = {};

Shopify.updateOptionsInSelector = function (selectorIndex) {
	switch (selectorIndex) {
		case 0:
			var key = 'root';
			var selector = jQuery('select.single-option-selector:eq(0)');
			break;
		case 1:
			var key = jQuery('select.single-option-selector:eq(0)').val();
			var selector = jQuery('select.single-option-selector:eq(1)');
			break;
		case 2:
			var key = jQuery('select.single-option-selector:eq(0)').val();
			key += ' / ' + jQuery('select.single-option-selector:eq(1)').val();
			var selector = jQuery('select.single-option-selector:eq(2)');
	}

	var initialValue = selector.val();
	selector.empty();
	var availableOptions = Shopify.optionsMap[key];

	for (var i = 0; i < availableOptions.length; i++) {
		var option = availableOptions[i];
		var newOption = jQuery('<option></option>').val(option).html(option);
		selector.append(newOption);
	}
	jQuery('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
		if (jQuery.inArray(jQuery(this).attr('data-value'), availableOptions) !== -1) {
			jQuery(this).removeClass('soldout').show().find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
		} else {
			jQuery(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled', 'disabled');
		}
	});
	if (jQuery.inArray(initialValue, availableOptions) !== -1) {
		selector.val(initialValue);
	}
	selector.trigger('change');
	jQuery('.single-option-selector').selectpicker('refresh');

};

Shopify.linkOptionSelectors = function (product) {
	// Building our mapping object.
	for (var i = 0; i < product.variants.length; i++) {
		var variant = product.variants[i];
		if (variant.available) {
			// Gathering values for the 1st drop-down.
			Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
			Shopify.optionsMap['root'].push(variant.option1);
			Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
			// Gathering values for the 2nd drop-down.
			if (product.options.length > 1) {
				var key = variant.option1;
				Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
				Shopify.optionsMap[key].push(variant.option2);
				Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
			}
			// Gathering values for the 3rd drop-down.
			if (product.options.length === 3) {
				var key = variant.option1 + ' / ' + variant.option2;
				Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
				Shopify.optionsMap[key].push(variant.option3);
				Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
			}
		}
	}

	// Update options right away.
	Shopify.updateOptionsInSelector(0);
	if (product.options.length > 1)
		Shopify.updateOptionsInSelector(1);
	if (product.options.length === 3)
		Shopify.updateOptionsInSelector(2);

	// When there is an update in the first dropdown.
	jQuery("select.single-option-selector:eq(0)").change(function () {
		Shopify.updateOptionsInSelector(1);
		if (product.options.length === 3)
			Shopify.updateOptionsInSelector(2);
		return true;
	});
	// When there is an update in the second dropdown.
	jQuery("select.single-option-selector:eq(1)").change(function () {
		if (product.options.length === 3)
			Shopify.updateOptionsInSelector(2);
		return true;
	});
};